// extracted by mini-css-extract-plugin
export default {"edit_part":"edit_edit_part__pkbbX","edit":"edit_edit__ki-q6"};